import { SectionHeaderProps } from "@/types";
import { cn } from "@/lib/utils";

export default function SectionHeader({
  title,
  subtitle,
  className,
  titleClassName,
  subtitleClassName,
  align = "center",
}: SectionHeaderProps) {
  const isLeft = align === "left";

  return (
    <div
      className={cn(
        "mb-6 md:mb-10",
        isLeft ? "text-left" : "text-center",
        className
      )}
    >
      <div
        className={cn(
          "bg-brand-green text-white px-3 py-1 sm:px-3.5 sm:py-1.5 font-oswald font-normal text-base sm:text-lg leading-normal tracking-[0.08em] uppercase inline-flex items-center gap-2 sm:gap-2.5 rounded-full",
          !isLeft && "justify-center",
          titleClassName,
          subtitle && "mb-4"
        )}
      >
        <span
          className="inline-block w-2 h-2 sm:w-2.5 sm:h-2.5 bg-white shrink-0"
          aria-hidden="true"
        />
        <span>{title}</span>
      </div>

      {subtitle && (
        <h2
          className={cn(
            "font-poppins font-normal text-xl sm:text-2xl lg:text-[28px] text-white",
            !isLeft && "max-w-7xl mx-auto",
            subtitleClassName
          )}
        >
          {subtitle}
        </h2>
      )}
    </div>
  );
}
